export enum Client {
  GRUPO_KUO = "KUO",
  BELTRAME = "BEL",
  EL_CORTE_INGLES = "ECI",
  INFRA = "INF",
  ANGLO_AMERICAN = "ANG",
  BANORTE = "BAN",
  ACELEN = "ACL",
  ANGLO_AMERICAN_BRAZIL = "AAOPBR",
}
